import { usePrevious } from 'marketplace-ui-common/hooks/usePrevious';
import { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const PrevLocationContext = /*#__PURE__*/createContext(undefined);
export function PrevLocationProvider({
  children
}) {
  const location = useLocation();
  const prevLocation = usePrevious(location);
  return /*#__PURE__*/_jsx(PrevLocationContext.Provider, {
    value: prevLocation,
    children: children
  });
}
export function usePrevLocationContext() {
  return useContext(PrevLocationContext);
}